import {flowRight as compose, get, has} from 'lodash';
import PropTypes from 'prop-types';
import React, {useEffect, useState} from 'react';
import {useQuery} from 'react-apollo';
import {Container} from 'react-bootstrap';
import {withTranslation} from 'react-i18next';
import 'react-placeholder/lib/reactPlaceholder.css';
import Select from './Select';
import PaginationLoadMore from './PaginationLoadMore';
import DateRangePicker from '../Dates/DateRangePicker';
import {Flex, MargedDiv} from './DatatableStyles';
import DatatableCore from './DatatableCore';
import moment from 'moment';

const DatatableLoadMore = ({columns, t, keyResult, query, additionalCriteria, additionalFilters, fetchPolicy}) => {
  const [limit, setLimit] = useState(10);
  const [forceLoading, setForceLoading] = useState(false);
  const [pageIndex, setPageIndex] = useState(0);
  const [listFirstElements, setListFirstElements] = useState(['']);
  const [created, setCreated] = useState({});

  useEffect(() => {
    setForceLoading(true);
    setTimeout(() => {
      setForceLoading(false);
    }, 500);
  }, [limit, additionalCriteria, created, pageIndex]);

  let variables = {
    criteria: {
      limit,
      created,
    },
    additionalCriteria,
  };

  if (pageIndex > 0) {
    variables.criteria.startingAfter = listFirstElements[pageIndex];
  }

  const {loading, error, data} = useQuery(query, {variables, fetchPolicy});
  const result = has(data, keyResult) ? get(data, keyResult) : {};

  const resetFilters = () => {
    setPageIndex(0);
    setListFirstElements(['']);
  };

  const onLimitChange = event => {
    setLimit(+event.target.value);
    resetFilters();
  };

  const previousPage = () => {
    setPageIndex(pageIndex - 1);
  };

  const nextPage = () => {
    if (result.rows.length === limit) {
      if (listFirstElements.length <= pageIndex + 1) {
        listFirstElements.push(result.rows[limit - 1].id);
      } else {
        listFirstElements[pageIndex] = result.rows[limit - 1].id;
      }
      setListFirstElements(listFirstElements);

      setPageIndex(pageIndex + 1);
    }
  };

  const onDatesChange = ({startDate, endDate}) => {
    let newDateFilter = {};
    if (startDate) {
      newDateFilter.gte = moment(startDate).startOf('day');
    }
    if (endDate) {
      newDateFilter.lte = moment(endDate).endOf('day');
    }
    setCreated(newDateFilter);
    resetFilters();
  };

  return (
    <Container fluid>
      <Flex>
        <Select value={limit} onChange={onLimitChange}/>
        <div className="filter">
          <MargedDiv>
            <DateRangePicker
              startDate={created.gte}
              endDate={created.lte}
              onDatesChange={onDatesChange}/>
          </MargedDiv>
          {additionalFilters}
        </div>
      </Flex>
      <br/>
      <DatatableCore
        columns={columns}
        loading={loading || forceLoading}
        error={error}
        result={result}
        limit={limit}
      />
      <PaginationLoadMore hasMore={result.hasMore || false} pageIndex={pageIndex} previousPage={previousPage} nextPage={nextPage}/>
    </Container>
  );
};

DatatableLoadMore.defaultProps = {
  additionalCriteria: {},
  additionalFilters: null,
  fetchPolicy: 'cache-first',
};

DatatableLoadMore.propTypes = {
  columns: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired,
  keyResult: PropTypes.string.isRequired,
  query: PropTypes.object.isRequired,
  additionalCriteria: PropTypes.object,
  additionalFilters: PropTypes.element,
  fetchPolicy: PropTypes.string,
};

export default compose(
  withTranslation('common'),
)(DatatableLoadMore);

